/**
 * Apple-only playback guards (iOS/iPadOS Safari).
 * Centralized helpers to decide when Howler should avoid starting playback
 * in background to prevent NotAllowed errors, deferring to WebAudio branch.
 */

// Detect iOS/iPadOS (including iPadOS desktop UA) or Safari
function isIOSLike(): boolean {
  try {
    const ua = navigator.userAgent || "";
    const iOS = /iPhone|iPad|iPod/i.test(ua);
    const iPadOS = /Macintosh/.test(ua) && (navigator as any).maxTouchPoints > 1;
    return iOS || iPadOS;
  } catch {
    return false;
  }
}

function isSafari(): boolean {
  try {
    const ua = navigator.userAgent || "";
    return /Safari/i.test(ua) && !/Chrome|Chromium|Edge/i.test(ua);
  } catch {
    return false;
  }
}

function isDocumentHidden(): boolean {
  try {
    return typeof document !== "undefined" ? !!document.hidden : false;
  } catch {
    return false;
  }
}

/**
 * Returns true only when we are on Apple (iOS/iPadOS or Safari)
 * AND the page is hidden, meaning Howler should not attempt to call play().
 * WebAudio scheduling should handle background continuation in this case.
 */
export function shouldBlockHowlerInAppleHidden(): boolean {
  return (isIOSLike() || isSafari()) && isDocumentHidden();
}

/**
 * Small helper to log decisions (guarded to avoid crashing in production).
 */
export function logAppleGuard(message: string) {
  try {
    // Keep prefix aligned with existing logs for easy filtering
    console.log(`🍎 [apple-guard] ${message}`);
  } catch {}
}

